import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
} from "reactstrap"
import Paginator from "components/Common/Paginator/Paginator"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import StatusButton from "./StatusButton"
import CardItem from "./CardItem"
import "./styles.scss"
import moment from "moment"
import ClientsService from "services/SalesDeveloper/ClientsService"
import { useDispatch } from "react-redux"
import { appendFilters } from "store/adminFilter/actions"
 
const ManageClients = (props) => {
    const clientsService = new ClientsService()
    const [status, setStatus] = useState('All')
    const [modal, setModal] = useState(false)
     const [searchWord, setSearchWord] = useState("")
    const [list, setList] = useState([])
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })
    const [filterData, setFilterData] = useState({ 
        from_date: "",
        to_date: "",
        has_deal: false,
        location: null
    })
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(appendFilters({compound_id: null}))
    },[])

    const toggle = () => {
        setModal(!modal)
    }

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }
 

    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {

            const params = {}
            if (status != 'All') params['status'] = status
            if (searchWord.trim().length) params['keyword'] = searchWord
       
                if (filterData ?.location?.length !== 0) params['location'] = filterData?.location?.map(item => item.value).join()
                if (filterData ?.has_deal) params['has_deal'] = filterData.has_deal ? 1 : 0
                if (filterData ?.from_date ?.length && filterData ?.to_date ?.length) {
                    params['date_range'] = `${filterData.from_date},${filterData.to_date}`
               } else if (filterData ?.from_date ?.length) {
                   params['date_range'] = `${filterData.from_date},${moment().format(`YYYY-MM-DD`)}`
               } else if (filterData ?.to_date ?.length) {
                   params['date_range'] = `0,${filterData.to_date}`
               }
                
            setFilterParams({ ...params })
        }, 1000)

        return () => clearTimeout(timeoutId)

    }, [status, searchWord,filterData.to_date,filterData.from_date,filterData.has_deal,filterData.location])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Clients</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>Manage Clients</h4>
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by Client Name, Unit Code, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-4 justify-content-between">
                        <Col md={10} className="mb-3">
                        <StatusButton statusValue={status} status={"All"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Wrong number"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Busy"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Unreachable"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Not interested"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Uncontacted"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Interested to buy"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Interested to sell"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"VIP"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Deal"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Contracting"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Complain"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Pending"} setStatus={setStatus} />
                        </Col>
                        <Col sm={3} md={2} className="mb-3 d-flex flex-row-reverse">

                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive-crm table-responsive" style={{marginBottom:"11rem !important"}}>
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14 ">I.D</th>
                                                        <th className="font-size-14">Client Name</th>
                                                        <th className="font-size-14">Phone</th>
                                                        <th className="font-size-14">Open Deals</th>
                                                        <th className="font-size-14">Sales rep</th>
                                                        <th className="font-size-14">Last Visited Date</th>
                                                        <th className="font-size-14">No of Searches</th>
                                                        <th className="font-size-14">Status</th>
                                                        <th className="font-size-14"></th>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {list.map((item, index) => {
                                                        return (
                                                            <CardItem
                                                                key={index}
                                                                item={item}
                                                                history={props.history}
                                                                setShouldGetData={setShouldGetData}
                                                             />
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={clientsService}
                                    pageOptions={pageOptions}
                                    setData={(data) => setList([...data])}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row >
                    </div>
                    {modal && <FilterModal
                        toggle={toggle}
                        modal={modal}
                        onSumbit={(data) => setFilterData((prevData) => ({ ...prevData, ...data }))}
                        filterData={filterData}
                    />}
             
                </Container>
            </div>
        </React.Fragment >
    )
}

export default ManageClients
